import { ajax as rAjax } from "rxjs/observable/dom/ajax";
import { getStore } from "store";
import { format, formatMessage } from "lib/globalize-util";
import { Observable } from "rxjs";
import { add as snackbarAdd } from "actions/snackbars";
import { isAccessControlError, checkAccessControlError } from "./../helpers/access-control";

let ajaxCounter = 0;

// adding a 'beforeunload' hook will cause occasional page unload alerts on IE
const isIE = window.navigator.userAgent.indexOf("MSIE") > 0 || !!navigator.userAgent.match(/Trident\/7\./);
if (!isIE) {
    window.addEventListener("beforeunload", (e) => {
        if (ajaxCounter > 0) {
            const dialogText = "Data is still syncing. Are you sure you want to leave?";
            e.returnValue = dialogText;
            return dialogText;
        } else {
            return null;
        }
    });
}

export const ajax = (params: any) => {
    let { hideBeforeUnloadWarning = false } = params;
    const retry = params?.retry ?? 11;
    const progressSubscriber = {
        complete: () => {
            ajaxCounter = ajaxCounter - 1;
        },
        error: () => {
            ajaxCounter = ajaxCounter - 1;
        },
        next: () => null,
    };

    if (typeof params === "string") {
        hideBeforeUnloadWarning = true;
        params = {
            url: params,
        };
    } else {
        if (params.method && params.method.toUpperCase() === "GET") {
            hideBeforeUnloadWarning = true;
        }
    }
    const store = getStore();
    const { scope } = store.getState();
    params = {
        crossDomain: true,
        headers: {
            "Content-Type": "application/json",
            Module: "base",
            "X-Requested-With": "XMLHttpRequest",
        },
        withCredentials: true,
        ...params,
    };

    if (!params.removeActiveBrand) {
        if (params.activeBrand) {
            params.headers["Active-Brand"] = params.activeBrand;
        } else if (scope.brand) {
            params.headers["Active-Brand"] = scope.brand._id;
        }
    }

    if (!hideBeforeUnloadWarning) {
        params.progressSubscriber = progressSubscriber;
        ajaxCounter = ajaxCounter + 1;
    }

    return (
        rAjax(params)
            /*.do(( response ) => {
            if (response.status >= 500 && (!params.method || params.method.toUpperCase() === "GET")) {
                throw new APIError(
                    "Error",
                    response.status,
                    "Error",
                );
            }

            if (response.status === 401) {
                throw new APIError(
                    "Unauthorized",
                    response.status,
                    "Unauthorized",
                );
            }
        })*/
            .retryWhen((attempts) => {
                return Observable.range(1, retry)
                    .zip(attempts, (i, error) => {
                        return { i, error };
                    })
                    .map(({ i, error }) => {
                        const seconds = Math.pow(2, i);
                        const cause = error.xhr?.response?.error || format("Could not connect to server");
                        switch (error.status) {
                            case 401:
                                // eslint-disable-next-line @typescript-eslint/no-require-imports
                                const me = require("models/me").default;
                                if (!params.handle401) {
                                    me.logout(true);
                                }
                                throw error;
                            case 403:
                                checkAccessControlError({ error: error.xhr.response });
                                if (isAccessControlError(error.xhr.response)) {
                                    error.message = error.xhr.response?.message ?? error.message;
                                }
                                throw error;
                            case 500:
                            case 501:
                            case 502:
                            case 503:
                                if (i > 2) {
                                    store.dispatch(
                                        snackbarAdd({
                                            message: formatMessage("|cause|. Retrying in |seconds| seconds", {
                                                cause,
                                                seconds,
                                            }),
                                        }),
                                    );
                                }
                                if (i === retry) {
                                    throw new Error("max retries reached");
                                }
                                break;
                            default:
                                throw error;
                        }

                        return seconds;
                    })
                    .flatMap((seconds) => {
                        return Observable.timer(1000 * seconds);
                    });
            })
    );
};
